import React from 'react'
import StyledText from '../../components/StyledComponents/StyledText';
import styled from 'styled-components';
import { useTheme } from '../../middleware/ThemeContext';
import { CheckBox } from '@mui/icons-material';
import { Data } from '../../types/types';

interface PrivateNotes {
    // title?: string;
    scope: 'CONTACTS' | 'ORGANIZATION';
    data: any[];
    initialState: Data;
    updataNotes: (data_id: number, pNotesCount: number) => void;
}

const PrivateNotesMerge: React.FC<PrivateNotes> = ({ scope, data, initialState, updataNotes }) => {
  const {theme} = useTheme();
  let columnsClass: string;
    if(data?.length == 2){
        columnsClass = 'col-6';
    } else if (data?.length == 3) {
        columnsClass = 'col-4';
    } else if (data?.length > 3) {
        columnsClass = 'col-3';
    }

    const hanledClick = (itemID: number, length: number) => {
      if(length === 0) return '';
      initialState.metaData.id != itemID &&
      updataNotes(itemID, length);
    }

  return (
    <div>
      <StyledText className='my-3 ps-4' fontSize='16px'>{
      scope == 'ORGANIZATION' ? 
      'You can also merge Contacts of the organization' : 
      scope == 'CONTACTS' ? 'You can also merge private notes' : 
      null
      }</StyledText>
      <div style={{ display: 'flex' }}>
        {data?.map((item, index) => (

          <div key={index} className={columnsClass} style={{ padding: '0px 12px' }}>
            <FieldNote theme={theme} onClick={() => hanledClick(item.id, 
              scope == 'CONTACTS' ?
              item?.privateNoteReferences?.length :
              scope == 'ORGANIZATION' ?
              item?.contactOrganizations?.length :
              0
            )}
              className={initialState.metaData.id === item.id ? 'cursor-not-allowed' : ''}
              >
              <div style={{ width: 'calc(100% - 24px)', overflow: 'hidden' }}>
                  <StyledText fontSize='12px' fontWeight={500} className='mb-1'>{
                    scope == 'CONTACTS' ? 'Private Notes' : scope == 'ORGANIZATION' ? 'Contacts' : null
                    }</StyledText>
                  <StyledText className='field-data' fontSize='14px' fontWeight={500} textColor={theme.CorporateTheme.colors.textSecondary} htmlTag={'p'} style={{ overflow: 'hidden' }}>
                      {scope == 'CONTACTS' ? 
                        `Total Notes: ${item?.privateNoteReferences?.length || 0}` :
                        scope == 'ORGANIZATION' ?
                        `Total Contacts: ${item?.contactOrganizations?.length || 0}` :
                        null
                      }
                  </StyledText>
              </div>
              { scope == 'CONTACTS' ?
                    item?.privateNoteReferences?.length > 0 ?
                      <div className='check'>
                          <CheckBox htmlColor={initialState?.privateNotes?.some(note => note.data_id === item.id) || initialState.metaData.id === item.id ? theme.CorporateTheme.colors.primary : theme.CorporateTheme.colors.border} />
                      </div>
                      : null
              :
              scope == 'ORGANIZATION' ?
                  item?.contactOrganizations?.length > 0 ?
                  <div className='check'>
                      <CheckBox htmlColor={initialState?.contacts?.some(note => note.data_id === item.id) || initialState.metaData.id === item.id ? theme.CorporateTheme.colors.primary : theme.CorporateTheme.colors.border} />
                  </div>
                  : null
              :
                null
              }
            </FieldNote>
          </div>

        ))}
      </div>
    </div>
  )
}

const FieldNote =  styled.div`
  display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 5px;
    cursor: pointer;
    background-color: ${({theme}) => theme.CorporateTheme.colors.bannerBg};
    border-radius: 5px;
    & .field-data{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export default PrivateNotesMerge